export default __webpack_public_path__ + "4121d6e618d458ab0cab54867675ad64.svg";